import { useQuery } from '@tanstack/react-query';

import { ApiError } from '@/lib/errors';

import { portalHelplineService } from '../services/portalHelplineService';
import type { PortalHelplineRole } from '../types/schemas';

export const portalHelplineKeys = {
  all: ['portal-helpline'] as const,
  callable: (role: PortalHelplineRole) => [...portalHelplineKeys.all, 'callable', role] as const,
};

/**
 * Callable practitioners for the wizard. Kept fresh by the
 * `helpline.availability-changed` realtime listener and the reconnect
 * self-heal — no polling. 4xx errors don't retry; the UX layer handles the
 * contextual response.
 */
export function useCallablePractitioners(role: PortalHelplineRole) {
  return useQuery({
    queryKey: portalHelplineKeys.callable(role),
    queryFn: () => portalHelplineService.listCallable(role),
    staleTime: 0,
    gcTime: 60_000,
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
      return failureCount < 2;
    },
  });
}
